$(document).ready(function () {
    // CHECK IF THIS IS DENTIST TYPE PAGE:
    if ( $('.global-section').hasClass('dentist-management-page') ) {
        var apiUrl = 'api/news';
        var pattern = /news/;
        var key = 'news';
        var wrapperClass = 'jsManageNewsWrapper';
        var lastIndexClass = 'jsLastManageNewsIndex';
        var buttonClass = 'jsShowMoreLessManageNewsBtn';

        function jsManageArticlePagination() {
            var btn = $(this);
            jsManagementPagination(pattern, apiUrl, key, lastIndexClass,wrapperClass,buttonClass, btn);
        }

        hideShowButtons(pattern, buttonClass , $('.' + lastIndexClass).text().trim().split(' ')[3]);
        $('.' + buttonClass).click(jsManageArticlePagination);

        window.onpopstate = function(event) {
            if ( (event.state && event.state.counter) || $('.dentist-management-page').length ) {
                window.location.reload();
            }
        };
    }
});

function resetManageNewsPagination() {
    resetManagePagination(/news/, 'api/news', 'news', 'jsLastManageNewsIndex', 'jsManageNewsWrapper', 'jsShowMoreLessManageNewsBtn');
}
